<div class="container">
  <div class="card offset xp">
    <h1>Sold Proposals/Addenda Documents</h1>

    <div class="mt-3 mb-5">
      <ng-template #effectiveDate
        let-effectiveDate="effectiveDate">
        <div class="custom-cell-margin">
          {{effectiveDate}}

        </div>
      </ng-template>
      <ng-template #expirationDate
        let-expirationDate="expirationDate">
        <div class="custom-cell-margin">
          {{expirationDate}}

        </div>
      </ng-template>
      <ng-template #documentType
        let-documentType="documentType">
        <div class="custom-cell-margin">
          {{documentType}}
        </div>
      </ng-template>
      <ng-template #rev
        let-rev="rev">
        <div class="custom-cell-margin">
          {{rev}}
        </div>

      </ng-template>
      <ng-template #revisionDate
        let-revisionDate="revisionDate">
        <div class="custom-cell-margin">
          {{revisionDate}}
        </div>

      </ng-template>
      <ng-template #pdfIcon
        let-icon="icon">
        <i class="fa fa-file-pdf-o"></i>
      </ng-template>



      <div class="mt-4 mb-4">
        <ag-grid-angular style="width: 100%; height: 100%;"
          [rowData]="soldList"
          [columnDefs]="soldProposalsHeader"
          [rowSelection]="'multiple'"
          [rowMultiSelectWithClick]="true"
          [defaultColDef]="defaultColDef"
          [enableCellTextSelection]="true"
          [suppressRowClickSelection]="false"
          [pagination]="false"
          class="ag-theme-quartz"
          overlayNoRowsTemplate="<span></span>"
          (gridReady)="onGridReadyAddendaDocuments($event)"></ag-grid-angular>

      </div>

    </div>
  </div>
</div>
<div *ngIf="showCancelConfirmation"
  class="timeout-modal">
  <div class="modal-content">
    <h2><b>Error</b></h2>
    <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
      class="close-icon"
      (click)="confirmCancel(false)">
      <i class="fa fa-times"
        aria-label="Close"></i>
    </button>
    <hr class="hrstyle">
    <div>
      <span class="fa fa-exclamation-circle"
        style="color:#b83b2f;"></span> <span style="color:#040404;margin-left:6px">
        Document is not found</span>
    </div>
  </div>
</div>